import _ from 'lodash';

import { BorrowerKeyEnabledConfig } from 'types/dashboard';
import { BorrowingBaseReportGQLType } from 'types/dashboard-core-gqlTypes.generated';

/**
 * Feature flags for borrowers in each environment
 */

export const eventsEnabledBorrowerKeys: BorrowerKeyEnabledConfig = {
  stage: ['acmeCorp'],
  prod: ['acmeCorp'],
};

export const isQAUser = (userEmail: string) => {
  return (
    _.startsWith(userEmail, 'test') && _.endsWith(userEmail, '@finleycms.com')
  );
};

export const isEligibilityCriteriaEnabled = (
  borrowingBaseReport: BorrowingBaseReportGQLType,
) => {
  return (
    borrowingBaseReport !== undefined &&
    borrowingBaseReport.eligibilityCriteriaCalculations &&
    !_.isEmpty(borrowingBaseReport.eligibilityCriteriaCalculations)
  );
};

export const isConcentrationLimitEnabled = (
  borrowingBaseReport: BorrowingBaseReportGQLType,
) => {
  return (
    borrowingBaseReport !== undefined &&
    borrowingBaseReport.concentrationLimitCalculations &&
    !_.isEmpty(borrowingBaseReport.concentrationLimitCalculations)
  );
};
